import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import theme from '../../components/theme';

export const CardList = styled.div`
  display: grid;
  width: 100%;
  ${mediaDesktop} {
    section {
      background: transparent;
    }
  }
`;

export const CollectedList = styled.div`
  background: #000000;

  ${mediaDesktop} {
    margin-top: 87px;
    padding-bottom: 60px;
  }
`;

export const FilterContainer = styled.div`
  max-width: 1080px;
  margin: 0 20px;
  ${mediaDesktop} {
    margin: auto;
  }
`;

export const CardsContainer = styled.div`
  max-width: 1080px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 26px;
  margin: 20px 20px 21px;
  ${mediaDesktop} {
    display: grid;
    margin: auto;
    grid-gap: 64px;
    grid-template-columns: repeat(auto-fit, 312px);
    justify-content: center;
  }
`;

export const NoItemsBlock = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;
  place-content: center;
  height: 420px;
  padding-bottom: 100px;
  font-family: ${theme.fonts.primary};
  font-weight: bold;
  
  & p:first-of-type{
    font-size: 18px;
    ${mediaDesktop} {
      font-size: 21px;
    }
  }
`;

export const NoItemsResetText = styled.p`
  color: ${theme.colors.lightGreen};
  cursor: pointer;
  user-select: none;
  text-transform: uppercase;
  border-bottom: 1px solid ${theme.colors.lightGreen};
  font-size: 14px;
  line-height: 20px !important;
  ${mediaDesktop} {
    line-height: 24px;
    letter-spacing: 1px;
    font-size: 18px !important;
  }
`;

export const StyleCollectionsHeadlineWrapper = styled.div`
  padding: 37px 0 7px 26px;
  ${mediaDesktop} {
    padding: 100px 0 23px 22px;
  }
`;

export const BottomLoader = styled.div`
  display: block;
`;
